/* Live Trustpilot-bedrijfsscore voor elke sterrenrij in het theme.
   Wordt geladen vanuit snippets/tw-tokens.liquid (elke pagina). Eén fetch per
   pagina (gecachet); werkt elk element met [data-tw-live-rating] bij (sterren
   + aria-label), elk [data-tw-live-count] (afgerond aantal, "1.600+") en elk
   [data-tw-live-label] (het woord bij de score, "Uitstekend").
   Draait bij het laden en opnieuw na shopify:section:load, want de
   theme-editor voegt secties opnieuw in zonder inline scripts uit te voeren.
   tw-testimonials.liquid gebruikt window.twTrustpilot.load voor de kaarten,
   buiten nl met de locale en taal van de bezoeker (04-09-2026). De score en
   het woord erbij komen hier uit de feed van de paginataal (html lang), zodat
   "Uitstekend" op de Spaanse winkel "Excelente" wordt; op nl is dat de
   Nederlandse feed, zoals altijd. */
(function () {
  var DEFAULT_BUSINESS = '617ff6896bc505ee409c533a';
  var DEFAULT_LOCALE = 'nl-NL';
  var DEFAULT_LANG = 'nl';
  var ENDPOINT = 'https://widget.trustpilot.com/trustbox-data/539ad60defb9600b94d7df2c';
  /* Winkeltaal naar Trustpilot-locale, gelijk aan de tabel in tw-testimonials.liquid. */
  var LOCALES = { nl: 'nl-NL', en: 'en-GB', de: 'de-DE', fr: 'fr-FR', es: 'es-ES', it: 'it-IT', da: 'da-DK', fi: 'fi-FI', sv: 'sv-SE' };
  var cache = {};

  /* Feed voor de paginataal: op nl de Nederlandse feed, anders die van de
     taal zodat het woord bij de score gelokaliseerd meekomt; score en aantal
     zijn in elke feed gelijk. Een taal die niet in de tabel staat: Engels. */
  function paginaFeed() {
    var taal = ((document.documentElement.lang || DEFAULT_LANG) + '').toLowerCase().split('-')[0];
    if (!LOCALES[taal]) taal = 'en';
    return { locale: LOCALES[taal], lang: taal };
  }

  /* Eén fetch per bedrijf, locale en taal; zonder locale en taal de Nederlandse feed. */
  function load(business, locale, lang) {
    business = business || DEFAULT_BUSINESS;
    locale = locale || DEFAULT_LOCALE;
    lang = lang || DEFAULT_LANG;
    var sleutel = business + '|' + locale + '|' + lang;
    if (!cache[sleutel]) {
      var url = ENDPOINT + '?businessUnitId=' + encodeURIComponent(business)
        + '&locale=' + encodeURIComponent(locale) + '&reviewsPerPage=50&reviewLanguages=' + encodeURIComponent(lang) + '&reviewStars=4,5';
      cache[sleutel] = fetch(url).then(function (res) {
        if (!res.ok) throw new Error('status ' + res.status);
        return res.json();
      });
      cache[sleutel].catch(function () { delete cache[sleutel]; });
    }
    return cache[sleutel];
  }

  function assets() { return window.twTpAssets || {}; }

  function maakSter(prefix, src, extra) {
    var img = document.createElement('img');
    img.className = prefix + extra;
    img.src = src;
    img.alt = '';
    img.width = 20;
    img.height = 20;
    return img;
  }

  function maakHalveSter(prefix) {
    var a = assets();
    var span = document.createElement('span');
    span.className = prefix + ' ' + prefix + '--half';
    var bg = document.createElement('img');
    bg.src = a.halfBg;
    bg.alt = '';
    bg.width = 20;
    bg.height = 20;
    var fg = document.createElement('img');
    fg.className = prefix + '-fg';
    fg.src = a.halfFg;
    fg.alt = '';
    fg.width = 14;
    fg.height = 13;
    span.appendChild(bg);
    span.appendChild(fg);
    return span;
  }

  /* Sterrenrij opnieuw opbouwen: vol / half (blokje half groen mét ster) /
     leeg (grijs blokje mét ster). Slaat over als de score al klopt. */
  function zetSterren(wrapper, score) {
    if (!wrapper || !score) return;
    var a = assets();
    if (!a.full || !a.empty) return;
    var prefix = wrapper.dataset.twStarPrefix || 'tw-trustpilot__star';
    var vorige = parseFloat(((wrapper.dataset.twScore || wrapper.getAttribute('aria-label') || '') + '').replace(',', '.'));
    if (vorige === score) return;
    wrapper.dataset.twScore = String(score);
    var sterLabel = (document.querySelector('meta[name="tw-stars-label"]') || {}).content || '__RATING__ van 5 sterren';
    wrapper.setAttribute('aria-label', sterLabel.replace('__RATING__', String(score).replace('.', ',')));
    wrapper.textContent = '';
    var vol = Math.floor(score);
    var half = score - vol >= 0.25;
    for (var i = 1; i <= 5; i++) {
      if (i <= vol) {
        wrapper.appendChild(maakSter(prefix, a.full, ''));
      } else if (half && i === vol + 1) {
        wrapper.appendChild(maakHalveSter(prefix));
      } else {
        wrapper.appendChild(maakSter(prefix, a.empty, ' ' + prefix + '--empty'));
      }
    }
  }

  function formatTotaal(totaal) {
    return totaal >= 100 ? (Math.floor(totaal / 100) * 100).toLocaleString(document.documentElement.lang || 'nl-NL') + '+' : String(totaal);
  }

  function ververs(root) {
    var wrappers = root.querySelectorAll('[data-tw-live-rating]');
    var counts = root.querySelectorAll('[data-tw-live-count]');
    var labels = root.querySelectorAll('[data-tw-live-label]');
    if (!wrappers.length && !counts.length && !labels.length) return;
    var feed = paginaFeed();
    load(document.documentElement.dataset.twTpBusiness, feed.locale, feed.lang).then(function (data) {
      var bu = data.businessUnit || {};
      if (bu.trustScore) {
        for (var i = 0; i < wrappers.length; i++) zetSterren(wrappers[i], bu.trustScore);
      }
      var totaal = bu.numberOfReviews && bu.numberOfReviews.total;
      if (totaal) {
        for (var j = 0; j < counts.length; j++) counts[j].textContent = formatTotaal(totaal);
      }
      /* Het woord bij de score ("Uitstekend") komt ook van Trustpilot mee. */
      var label = ((data.starsString || '') + '').trim();
      if (label) {
        for (var k = 0; k < labels.length; k++) {
          if (labels[k].textContent.trim() !== label) labels[k].textContent = label;
        }
      }
      document.documentElement.dataset.twTpScore = String(bu.trustScore || '');
    }).catch(function () { /* beginstand blijft staan */ });
  }

  window.twTrustpilot = { load: load, zetSterren: zetSterren, formatTotaal: formatTotaal, ververs: ververs };

  function init(root) { ververs(root && root.querySelectorAll ? root : document); }
  if (!window.fetch) return;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
